import { RouteRecordRaw } from "vue-router";
import { SearchtPage } from "@/pages/search/index";
import { PermissionsPage } from "@/pages/permissions/index";
import { NotFoundPage } from "@/pages/404/index";
import { AppsPage } from "@/pages/apps/index";

export const routes: Array<RouteRecordRaw> = [
  {
    path: "/404",
    name: "404",
    component: NotFoundPage,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "404",
  },
  {
    path: "/",
    redirect: "/search",
  },
  {
    path: "/search",
    name: "search",
    component: SearchtPage,
  },
  {
    path: "/permissions",
    name: "Permissions",
    meta: { acl: ["admin"] },
    component: PermissionsPage,
  },
  {
    path: "/apps",
    name: "Apps",
    component: AppsPage,
  },
];
